import { render, staticRenderFns } from "./VizionHome.vue?vue&type=template&id=be5dcfae&"
import script from "./VizionHome.vue?vue&type=script&lang=js&"
export * from "./VizionHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports